const development_tenant = {
    notification: 'Jesteś w trybie deweloperskim',
};
export default Object.freeze(development_tenant);
